var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c(
        "md-layout",
        { attrs: { "md-flex": "90", "md-flex-offset": "5" } },
        [
          _c(
            "md-card",
            { staticClass: "md-table-card content-table" },
            [
              _c("md-card-header", { staticClass: "md-title" }, [
                _vm._v("Billing report")
              ]),
              _c(
                "form",
                {
                  staticClass: "search-form",
                  attrs: { novalidate: "novalidate" },
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.searchForBilling.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-gutter": 24 } },
                    [
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "20", "md-flex-small": "30" } },
                        [
                          _c(
                            "md-input-container",
                            [
                              _c("label", { attrs: { for: "criteria" } }, [
                                _vm._v("Month")
                              ]),
                              _c(
                                "md-select",
                                {
                                  attrs: { id: "criteria" },
                                  on: { selected: _vm.searchForBilling },
                                  model: {
                                    value: _vm.filters.month,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "month", $$v)
                                    },
                                    expression: "filters.month"
                                  }
                                },
                                _vm._l(_vm.months, function(month) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: month.value,
                                      attrs: { value: month.value }
                                    },
                                    [_vm._v(_vm._s(month.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "20", "md-flex-small": "30" } },
                        [
                          _c(
                            "md-input-container",
                            [
                              _c("label", { attrs: { for: "criteria" } }, [
                                _vm._v("Year")
                              ]),
                              _c(
                                "md-select",
                                {
                                  attrs: { id: "criteria" },
                                  on: { selected: _vm.searchForBilling },
                                  model: {
                                    value: _vm.filters.year,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "year", $$v)
                                    },
                                    expression: "filters.year"
                                  }
                                },
                                _vm._l(_vm.years, function(year) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: year.value,
                                      attrs: { value: year.value }
                                    },
                                    [_vm._v(_vm._s(year.value))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        {
                          attrs: {
                            "md-flex": "10",
                            "md-flex-small": "10",
                            "md-flex-xsmall": "100",
                            "md-vertical-align": "center",
                            "md-align-xsmall": "center"
                          }
                        },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "search-btn md-raised md-icon-button btn",
                              attrs: {
                                type: "submit",
                                disabled: _vm.loading || _vm.$v.$invalid
                              }
                            },
                            [
                              _c("md-icon", {
                                staticClass: "icon",
                                attrs: { "md-iconset": "fa fa-search" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "stitch-loader",
                { attrs: { loading: _vm.loading, size: 45 } },
                [
                  _c(
                    "div",
                    { staticClass: "table" },
                    _vm._l(_vm.bill, function(data, idx) {
                      return _c(
                        "div",
                        {
                          key: idx,
                          staticClass: "accountContainer colorHover"
                        },
                        [
                          _c("div", { staticClass: "titleName" }, [
                            _vm._v(_vm._s(data.account.name))
                          ]),
                          _c("div", { staticClass: "titleLine styleRow" }, [
                            _c("p", { staticClass: "rowElements" }, [
                              _vm._v("Mediaconvert minutes")
                            ]),
                            _c("p", { staticClass: "rowElements" }, [
                              _vm._v("Bandwidth GB")
                            ]),
                            _c("p", { staticClass: "rowElements" }, [
                              _vm._v("Bandwidth count")
                            ]),
                            data.billingStorage !== undefined
                              ? _c("p", { staticClass: "rowElements" }, [
                                  _vm._v("Storage")
                                ])
                              : _vm._e(),
                            _c("p", { staticClass: "rowElements" }, [
                              _vm._v("TOTAL")
                            ])
                          ]),
                          _c("div", { staticClass: "styleRow" }, [
                            _c("div", { staticClass: "rowElements" }, [
                              _c("div", { staticClass: "info" }, [
                                _c("div", [
                                  _c("p", [_vm._v("HD")]),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v(
                                      "Minutes: " +
                                        _vm._s(
                                          data.billingTranscode.mediaConvert.hdMinutesTranscoded.toFixed(
                                            2
                                          )
                                        )
                                    )
                                  ]),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v("Price: $0.015")
                                  ]),
                                  _c("br"),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v(
                                      "Total: $ " +
                                        _vm._s(_vm.mediaConvertHD(idx))
                                    )
                                  ])
                                ]),
                                _c("div", [
                                  _c("p", [_vm._v("SD")]),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v(
                                      "Minutes: " +
                                        _vm._s(
                                          data.billingTranscode.mediaConvert.sdMinutesTranscoded.toFixed(
                                            2
                                          )
                                        )
                                    )
                                  ]),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v("Price: $0.0075")
                                  ]),
                                  _c("br"),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v(
                                      "Total: $ " +
                                        _vm._s(_vm.mediaConvertSD(idx))
                                    )
                                  ])
                                ])
                              ]),
                              _c("div", { staticClass: "priceTotal" }, [
                                _c("p", [
                                  _vm._v(
                                    "Total: $ " +
                                      _vm._s(_vm.mediaConvertTotal(idx))
                                  )
                                ])
                              ])
                            ]),
                            _c("div", { staticClass: "rowElements" }, [
                              _c("div", { staticClass: "info" }, [
                                _c("div", [
                                  _c("p", [_vm._v("GB consumed")]),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v(
                                      " GB: " +
                                        _vm._s(
                                          data.billingBandwith.missTotalGB +
                                            data.billingBandwith.hitTotalGB
                                        )
                                    )
                                  ]),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v(
                                      "PriceGB: $ " +
                                        _vm._s(
                                          data.billingBandwith.hitAWSPricePerGB
                                        )
                                    )
                                  ]),
                                  _c("br"),
                                  _c("br")
                                ])
                              ]),
                              _c("div", { staticClass: "priceTotal" }, [
                                _c("p", [
                                  _vm._v(
                                    "Total: $ " +
                                      _vm._s(
                                        _vm
                                          .calculateBandwidthTotal(idx)
                                          .toFixed(2)
                                      )
                                  )
                                ])
                              ])
                            ]),
                            _c("div", { staticClass: "rowElements" }, [
                              _c("div", { staticClass: "info" }, [
                                _c("div", [
                                  _c("p", [_vm._v("Requests count")]),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v(
                                      "Request: " +
                                        _vm._s(_vm.mediaRequest(idx))
                                    )
                                  ]),
                                  _c("sub", { staticClass: "description" }, [
                                    _vm._v(
                                      "Price per 10k: $" +
                                        _vm._s(
                                          data.billingBandwith
                                            .AWSPricePer10_000Requests
                                        )
                                    )
                                  ]),
                                  _c("br"),
                                  _c("br")
                                ])
                              ]),
                              _c("div", { staticClass: "priceTotal" }, [
                                _c("p", [
                                  _vm._v(
                                    "Total $ " +
                                      _vm._s(_vm.totalMediaRequest(idx))
                                  )
                                ])
                              ])
                            ]),
                            data.billingStorage !== undefined
                              ? _c("div", { staticClass: "rowElements" }, [
                                  _c("div", { staticClass: "info" }, [
                                    _c("div", [
                                      _c("p", [_vm._v("Storage")]),
                                      _c(
                                        "sub",
                                        { staticClass: "description" },
                                        [
                                          _vm._v(
                                            "ThumbnailGB: " +
                                              _vm._s(
                                                data.billingStorage !==
                                                  undefined
                                                  ? data.billingStorage.thumbnailFilesGB.toFixed(
                                                      2
                                                    )
                                                  : "-"
                                              )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "sub",
                                        { staticClass: "description" },
                                        [
                                          _vm._v(
                                            "TranscodedFilesGB: " +
                                              _vm._s(
                                                data.billingStorage !==
                                                  undefined
                                                  ? data.billingStorage.transcodedFilesGB.toFixed(
                                                      2
                                                    )
                                                  : "-"
                                              )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "sub",
                                        { staticClass: "description" },
                                        [
                                          _vm._v(
                                            "UploadedFilesGB: " +
                                              _vm._s(
                                                data.billingStorage !==
                                                  undefined
                                                  ? data.billingStorage.uploadedFilesGB.toFixed(
                                                      2
                                                    )
                                                  : "-"
                                              )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "sub",
                                        { staticClass: "description" },
                                        [
                                          _vm._v(
                                            "PriceGB: $" +
                                              _vm._s(_vm.priceStorageGB)
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _c("div", { staticClass: "priceTotal" }, [
                                    _c("p", [
                                      _vm._v(
                                        "Total $ " +
                                          _vm._s(_vm.totalBillingStorage(idx))
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _c("div", { staticClass: "rowElements" }, [
                              _c("p", [
                                _vm._v(
                                  "$ " +
                                    _vm._s(_vm.calculateTotal(idx).toFixed(2))
                                )
                              ]),
                              _c("div", { staticClass: "editPercentage" }, [
                                _c("p", [
                                  _vm._v(
                                    "+ " +
                                      _vm._s(
                                        data.account.addBillingPercentage
                                          ? data.account.addBillingPercentage
                                          : _vm.percentage
                                      ) +
                                      " %"
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "editBtn",
                                      on: {
                                        click: function($event) {
                                          return _vm.editPercentage(
                                            data.account._id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("md-icon", {
                                        staticClass: "editIcon",
                                        attrs: {
                                          "md-iconset": "fa fa-pencil-alt"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceTotal priceFinal" },
                                [
                                  _c("p", { staticClass: "totalFinal" }, [
                                    _vm._v(
                                      "Total: $ " +
                                        _vm._s(
                                          _vm.totalReceivable10(
                                            idx,
                                            data.account.addBillingPercentage
                                              ? data.account
                                                  .addBillingPercentage
                                              : _vm.percentage
                                          )
                                        )
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm.noData
                    ? _c("div", { attrs: { id: "no-results" } }, [
                        _c(
                          "div",
                          { staticClass: "message" },
                          [
                            _c("md-icon", {
                              attrs: {
                                "md-iconset": "fa fa-exclamation-circle"
                              }
                            }),
                            _vm._v("No items to show")
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b844f7c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b844f7c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/report/NewBilling.vue
// module id = 1004
// module chunks = 0